<template>
  <section>
    <div class="price-list-select-modal">
      <div
        class="price-list-select-modal__row"
        v-for="(item, index) in priceLists"
        v-bind:key=index
      >
        <button
          class="price-list-select-modal__row__button"
          type="button"
          @click="onSelectPriceList(index)"
        >{{
          item.name
        }}
        </button>
        <img
          width="200"
          alt=""
          class="price-list-select-modal__row__arrow"
          src="@/assets/img/arrow/arrow-next-long-blue.svg"
        />
      </div>
    </div>
  </section>
</template>

<script>

/**
 * @description Выбран прайс-лист.
 * @type {string}
 */
const ON_SELECT_PRICE_LIST = 'select-price-list';
export default {
  name: 'PriceListsSelectModal',
  methods: {
    /**
     * @description Событие выбора прайс-листа
     * @param {number} index
     * @returns {void}
     */
    onSelectPriceList(index) {
      const selectedPriceList = this
        .priceLists[index];
      this.$emit(ON_SELECT_PRICE_LIST, selectedPriceList);
    },
  },
  props: {
    /**
     * @description Прайс-листы
     * @type array<PriceList>
     */
    priceLists: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
.price-list-select-modal {
  display: grid;
  row-gap: 15px;
  margin-block: 6px;
  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 25px;
    overflow-wrap: anywhere;
    &__button {
      font-size: 20px;
      text-align: left;
    }
    &__button:hover {
      color: #0076c4;
    }
    &__arrow {
      height: 20px;
      width: 50px;
    }
  }
}

@media screen and (max-width: 480px) {
  .price-list-select-modal {
    &__row {
      &__button {
        font-size: 18px;
      }
    }
  }
}
</style>
